import React from 'react'
import {Button, Col, Row, Spin} from 'antd'
import dayjs from 'dayjs'
import 'dayjs/locale/cs'
import ReactComponent from '../app/ReactComponent'

dayjs.locale('cs')

export class SlotRecommendations extends ReactComponent {

  formatDayWithCapital(date) {
    const dayName = dayjs(date).format('dd')
    return dayName.charAt(0).toUpperCase() + dayName.slice(1)
  }

  render() {
    const {recommendations, loading, onSelectSlot} = this.props

    return (
      (loading) ?
        <div className="mt-3 mb-2 ta-center">
          <Spin spinning={true} className="mr-2"/>Načítání doporučených termínů...
        </div>

        :

        (!recommendations || recommendations.length === 0) ? null :

          <div className="mt-3">
          <h4 className="_secondary-text mb-1">Doporučené termíny pro Vás:</h4>
          <div>
            {recommendations.map((service, serviceIndex) => (
              <div key={serviceIndex} style={{marginBottom: '1em'}}>
                {service.days?.map((day) =>
                  day.slots?.map((slot, slotIndex) => (
                    <div>
                      <Button
                        key={slotIndex}
                        className="btn btn-flat mb-1 btn-slot-recommendations"
                        size="small"
                        type="default"
                        variant="text"
                        disabled={slot.free_capacity === 0}
                        onClick={() => onSelectSlot(slot)}
                      >
                        <Row align="middle">
                          <Col span={24} className="ta-left _text-primary-text pl-2 pr-2">{this.formatDayWithCapital(slot.slot_start)} {dayjs(slot.slot_start).format('DD.MM.YYYY, H:mm')}</Col>
                          <Col span={24} className="ta-left pl-2 pr-2 _secondary-text" style={{fontWeight: '500'}}>{service.service_name}</Col>
                        </Row>
                      </Button>
                    </div>
                  ))
                )}
              </div>
            ))}
          </div>
        </div>
    )
  }
}
